// initial state
import {menuProps as mp} from "../../constants/menus";

const state = {
    list: jsonData.menus.list,
}

// getters
const getters = {
    get: (state) => (id) => state.list.find((menu) => menu.id === id),
    getName: (state, getters) => (id) => getters.get(id)[mp.NAME],
    getLink: (state, getters) => (id) => getters.get(id)[mp.LINK],
    getSeo: (state, getters) => (id) => getters.get(id)[mp.SEO],
}

// actions
const actions = {
}

// mutations
const mutations = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
